import { configureStore } from "@reduxjs/toolkit";
import { reducer as formReducer } from 'redux-form';
import contentReducer from "./content-slice";
import displayReducer from "./display-slice";
import ecommerceReducer from "./ecommerce-slice";
import phoneFormReducer from "./phone-form-slice";
import quizReducer from "./quiz-slice";
import serviceReducer from "./service-slice";
import settingsReducer from "./settings-slice";
import historyReducer from "./history-slice";
import { quizAPI } from '../services/api.service';

export const store = configureStore({
  reducer: {
    content: contentReducer,
    settings: settingsReducer,
    display: displayReducer,
    quiz: quizReducer,
    history: historyReducer,
    form: formReducer,
    service: serviceReducer,
    ecommerce: ecommerceReducer,
    phoneForm: phoneFormReducer,
    [quizAPI.reducerPath]: quizAPI.reducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(quizAPI.middleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;